import { render, staticRenderFns } from "./SectionPlanData.vue?vue&type=template&id=98649f52&"
import script from "./SectionPlanData.vue?vue&type=script&lang=js&"
export * from "./SectionPlanData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports